module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABXklEQVR4Xu2bMW7DMAwASQ95RT/SvV9IlnRIF9tPsr0kQ7K0X8jej/QVHczCBQLYhhIggCXB4GXKEFDWhZJFHqTi/KPO5y8AIAOcE8i2BLquO/R9/zbwL4riWpblKcd/kQXAMHkzO44nrKofOSBkAdA0zVlV92MAZnap6/o9dRZkAdC27aeIbGeT/aqqageAxATIgMTA/4djCbAHsAnyFuA1yDmAgxAnQY7CUwLUAhRDVIOUw/QDUlen9ANSE6cfsJaGyK1vr6qbCFnyKiIvs7g/IvK99Fhm9vvIOwT3gFDffukHSx3vnncIAgj17VM/8NLj3fMOAAiRdr8EBiiuN8Gl1988Hl4AL4AXwAvgBfACeAG8AF4ALzAhgBhBjCBGECOIkdil+Dw+YiQ1ccTIWsRIzMygJea9Jeb+woT7KzNj7zB8d3dpKuYG+2zsLAehZx8y5u8BEJPuGmK7z4A/eX8+UDc4SwgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.png
// module id = Alss
// module chunks = 5